import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Icon, Tooltip, Select, Switch, Checkbox, DatePicker } from 'antd';
import { SmartCollectTransactionOrders } from '../../../../models';
import { connect } from 'react-redux';
import { alertify, handleApiExceptions } from '../../../../app_methods';
import moment from 'moment';
import { cloneDeep } from 'lodash';


let OrderForm = (props) => {

    const { form } = props;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
    const validations = SmartCollectTransactionOrders.validations;
    const [isGenerating, setIsGenerating] = useState(false);
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
    const paymentType = getFieldValue('payment_type');
    const allowedCollectionModes = getFieldValue('allowed_collection_modes')
    const amount = getFieldValue('amount');
    const [date, setDate] = useState(null);
    const [isBankAccountEnabled, setBankAccountEnabled] = useState(false);


    useEffect(() => {
        const perTransactionAmount = paymentType === 'single_payment' ? amount : null;
        setFieldsValue({ "per_transaction_amount": perTransactionAmount })
    }, [paymentType]);

    useEffect(() => {
        if (paymentType === 'single_payment') {
            setFieldsValue({ "per_transaction_amount": amount })
        }
    }, [amount]);

    let is_upi_creation_enabled = props?.current_user?.smart_collect_virtual_account_settings?.enable_virtual_upi_handle_creation
    let allowed_payment_modes = props?.current_user?.smart_collect_virtual_account_settings?.allowed_payment_modes
    let bank_payment_modes = allowed_payment_modes.filter(x => ["IMPS", "NEFT", "RTGS"].includes(x))

    function range(start, end) {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }

    function getDisabledHours() {
        var hours = [];
        for (let i = 0; i < moment().hour(); i++) {
            hours.push(i);
        }
        return hours;
    }

    function getDisabledMinutes(selectedHour) {
        var minutes = [];
        if (selectedHour === moment().hour()) {
            for (var i = 0; i < moment().minute(); i++) {
                minutes.push(i);
            }
        }
        return minutes;
    }

    function disabledDate(current) {
        return current && current < moment().startOf("day")
    }


    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            if (parseFloat(form.getFieldValue("per_transaction_amount")) > parseFloat(form.getFieldValue('amount'))) {
                alertify("Oops!", `Per Transaction Amount exceeds Order amount.`, "error");
                return;
            }
            const formData = cloneDeep(form.getFieldsValue());

            if (getFieldValue('allowed_collection_modes').includes('upi')) {
                if(formData.allowed_payment_modes) 
                { 
                    formData.allowed_payment_modes.push('UPI');
                } else { 
                    formData.allowed_payment_modes = ['UPI'];
                }
            }
            props.onSubmit(formData);
        });
    };

    const generateUniqueCode = () => {
        setIsGenerating(true);
        SmartCollectTransactionOrders.generate_order_urn().then(response => {
            if (response.success) form.setFieldsValue({ "unique_request_number": response.data.data.unique_request_number })
            setIsGenerating(false);
        }).catch(error => {
            setIsGenerating(false);
            handleApiExceptions(error);
        })
    };


    const renderUniqueCodeExtra = () => {
        return (
            <Tooltip title="Generate Random">
                <Icon type="setting" spin={isGenerating} onClick={generateUniqueCode} />
            </Tooltip>
        )
    };


    return (
        <Form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Customer Name">
                        {getFieldDecorator("customer_name", {
                            rules: validations.customer_name
                        })(<Input autoComplete='off' prefix={<Icon type="profile" />} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Customer Phone">
                        {getFieldDecorator("customer_phone", {
                            rules: validations.customer_phone
                        })(<Input autoComplete='off' prefix={<Icon type="phone" />} />)}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Customer Email">
                        {getFieldDecorator("customer_email", {
                            rules: validations.customer_email
                        })(<Input autoComplete='off' prefix={<Icon type="mail" />} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Unique request number">
                        {getFieldDecorator("unique_request_number", {
                            rules: validations.unique_request_number
                        })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderUniqueCodeExtra()} />)}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Amount">
                        {getFieldDecorator("amount", {
                            rules: validations.amount
                        })(<Input autoComplete='off' prefix={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />} />)}
                    </Form.Item>
                </div>

                <div className=" col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Collection Mode">
                        {getFieldDecorator('allowed_collection_modes', {
                            rules: validations.allowed_collection_modes,
                        })(
                            <Checkbox.Group onChange={(checkedValues) => setBankAccountEnabled(checkedValues.includes('bank_account'))}>
                                {bank_payment_modes.length > 0 ? <Checkbox value="bank_account">Bank Account</Checkbox> : null}
                                {is_upi_creation_enabled && allowed_payment_modes.includes('UPI') ? <Checkbox value="upi">UPI</Checkbox> : null}
                            </Checkbox.Group>
                        )}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Payment Type">
                        {getFieldDecorator("payment_type", {
                            rules: validations.payment_type,
                            placeholder: "Select payment type",
                        })(
                            <Select placeholder="Select payment type">
                                <Select.Option value="single_payment">Single Payment</Select.Option>
                                <Select.Option value="multiple_payment">Multiple Payment</Select.Option>
                            </Select>
                        )}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Per Transaction Amount">
                        {getFieldDecorator("per_transaction_amount", {
                            rules: validations.per_transaction_amount
                        })(<Input autoComplete='off' disabled={paymentType === 'single_payment'} prefix={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />} />)}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Notification Cycle">
                        {getFieldDecorator("notification_cycle_type", {
                            rules: validations.notification_cycle_type,
                            initialValue: ''
                        })(<Select disabled={paymentType == "single_payment"}>
                            <Select.Option value="" >None</Select.Option>
                            <Select.Option value="daily">Daily</Select.Option>
                            <Select.Option value="weekly">Weekly</Select.Option>
                            <Select.Option value="monthly">Monthly</Select.Option>
                            <Select.Option value="yearly">Yearly</Select.Option>
                        </Select>)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Notify Customer on Create">
                        {getFieldDecorator('notify_customer_on_create', {
                            initialValue: true
                        })(<Switch defaultChecked />)}
                    </Form.Item>
                </div>
            </div>

            <div className="row">
                <div className=" col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Expiry Date">
                        {getFieldDecorator("expiry_date", {
                            rules: validations.expiry_date
                        })(<DatePicker
                            onChange={d => setDate(d)}
                            style={{ width: "100%" }}
                            format="YYYY-MM-DD HH:mm"
                            showTime={{
                                disabledMinutes: date && moment() < moment(date) ? undefined : getDisabledMinutes,
                                disabledHours: date && moment() < moment(date) ? undefined : getDisabledHours, format: 'HH:mm'
                            }}
                            disabledDate={disabledDate}
                        // disabledDate={(date) => date.valueOf() <= moment().valueOf()} 
                        />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    {isBankAccountEnabled ?
                        <Form.Item label="Payment Modes">
                            {getFieldDecorator("allowed_payment_modes", {
                                rules : [{ required: isBankAccountEnabled, message: "Select atleast one." }],
                                initialValue: isBankAccountEnabled ? bank_payment_modes : []
                            })(<Select placeholder="Select Payment Modes" mode="multiple" defaultValue={bank_payment_modes}>
                                {bank_payment_modes.map((key, index) => <Select.Option key={index} value={key}>{key}</Select.Option>)}
                            </Select>)}
                        </Form.Item>
                        : null}
                </div>
            </div>

            <Button
                className="pl-0 mb-2"
                type="link"
                onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
            >
                {showAdvancedOptions ? "Hide Advanced Options" : "Show Advanced Options"}
                <Icon type={showAdvancedOptions ? "down" : "right"} />
            </Button>

            {
                showAdvancedOptions ?
                    <div className="d-flex flex-wrap">
                        <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 1">
                            {getFieldDecorator("udf1", {
                                rules: validations.udf1
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>

                        <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 2">
                            {getFieldDecorator("udf2", {
                                rules: validations.udf2
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>

                        <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 3">
                            {getFieldDecorator("udf3", {
                                rules: validations.udf3
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>

                        <Form.Item style={{ width: "30%" }} className="mr-2" label="UDF 4">
                            {getFieldDecorator("udf4", {
                                rules: validations.udf4
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>

                        <Form.Item style={{ width: "30%" }} label="UDF 5">
                            {getFieldDecorator("udf5", {
                                rules: validations.udf5
                            })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                        </Form.Item>
                    </div> : null
            }

            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>{'Submit'} </Button>
            </div>
        </Form >
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

OrderForm = Form.create()(OrderForm);

export default connect(mapStateToProps)(OrderForm);